import { filterNames } from '../constants'

export const filterTypes = [
  { label: 'Tipo de método de devolución', value: filterNames.deliveryMethod, source: 'deliveryMethods' },
  { label: 'Región de la devolución', value: filterNames.region, source: 'deliveryMethods' },
  { label: 'Región de envío', value: filterNames.region, source: 'shippingMethods' },
  { label: 'Servicio de logística', value: filterNames.carrierService, source: 'shippingMethods' },
  { label: 'Servicio de logística', value: filterNames.carrierService, source: 'deliveryMethods' },
]
